<template>

  <m-card311 :image="product.thumbnail" :alt="product.name" class="product-card-311 ">

    <template #p-1>
      <h1 class="h6 my-1">{{ product.name }}</h1>
    </template>


    <template #p-2>
      <m-product-price100 class="text-center product-card-311-price" :product="product"/>
    </template>

    <template #p-3>
      <div class="product-card-311-description" v-html="product.description"></div>
    </template>


  </m-card311>
</template>

<script>
import {shoppingCartFunctions} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import mCard311 from "../../Cards/Card311";
import mA from '../../Tags/A'
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'

export default {
  name: "ProductCard311",
  components: {mCard311, mA, mProductCardQuantityManager1, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
</style>